const LOG_INFO = 'INFO';
const LOG_INCIDENT = 'INCIDENT';
const LOG_TASK = 'TASK';

const ASSIGN_DRIVER = 'ASSIGN_DRIVER';
const DELETE_CARGO_MANIFEST = 'DELETE_CARGO_MANIFEST';
const CHANGE_JOURNEY_STATUS = 'CHANGE_JOURNEY_STATUS';
const UNASSIGN_DRIVER = 'UNASSIGN_DRIVER';
const UPDATE_SHIPPER_ORDER = 'UPDATE_SHIPPER_ORDER';
const EDIT_SHIPPER_ORDER_BY_SHIPPER = 'EDIT_SHIPPER_ORDER_BY_SHIPPER';
const CREATE_SHIPPER_ORDER = 'CREATE_SHIPPER_ORDER';
const UPDATE_PRICE = 'UPDATE_PRICE';
const UPDATE_PRICE_BY_STANDSTILL = 'UPDATE_PRICE_BY_STANDSTILL';
const UPDATE_PRICE_BY_INCIDENT = 'UPDATE_PRICE_BY_INCIDENT';
const UPLOAD_CARGO_MANIFEST = 'UPLOAD_CARGO_MANIFEST';
const ACTION_MANUAL_BILLING = 'ACTION_MANUAL_BILLING';
const UPDATE_COST_INCREMENT = 'UPDATE_COST_INCREMENT';
const CANCEL_SHIPPER_ORDER = 'CANCEL_SHIPPER_ORDER';
const EMAIL_OFFER_SENT = 'EMAIL_OFFER_SENT';
const ACTION_OTHER = 'ACTION_OTHER';
const REASON_OTHER = 'REASON_OTHER';
const JOURNEY_LAUNCHED_TO_POOL = 'JOURNEY_LAUNCHED_TO_POOL';
const SCAN_SKIPPED = 'SCAN_SKIPPED';
const ACTIONS_WITHOUT_COMMENT_FIELD = [UNASSIGN_DRIVER];
const APPOINTMENT_BOOKED = 'APPOINTMENT_BOOKED';
const JOURNEY_STOP_TIME_UPDATED = 'JOURNEY_STOP_TIME_UPDATED';
const CHAT_SENT_AUTOMATICALLY = 'CHAT_SENT_AUTOMATICALLY';

const LOG_REASONS = {
  [ASSIGN_DRIVER]: ['SPECIFIC_DRIVER', 'NOT_ACCEPTED_AUTOMATICALLY', REASON_OTHER],
  [DELETE_CARGO_MANIFEST]: [
    'WRONG_PICTURE',
    'BAD_PICTURE',
    'BAD_FORMAT',
    'WRONG_STOP',
    'MISSING_PAGES',
    'INCOMPLETE',
    'MISSING_BL',
    REASON_OTHER,
  ],
  [CHANGE_JOURNEY_STATUS]: [REASON_OTHER],
  [UNASSIGN_DRIVER]: ['CARRIER_IS_UNWILLING', 'CARRIER_IS_UNABLE', 'SYSTEM_MISMATCH'],
  [UPDATE_SHIPPER_ORDER]: [REASON_OTHER],
  [EDIT_SHIPPER_ORDER_BY_SHIPPER]: [REASON_OTHER],
  [CREATE_SHIPPER_ORDER]: [REASON_OTHER],
  [UPDATE_PRICE]: ['NOT_ACCEPTED_AUTOMATICALLY', 'GROUPAGE', REASON_OTHER],
  [UPDATE_PRICE_BY_STANDSTILL]: ['STANDSTILL', REASON_OTHER],
  [UPDATE_PRICE_BY_INCIDENT]: ['INCIDENT', REASON_OTHER],
  [UPLOAD_CARGO_MANIFEST]: [REASON_OTHER],
  [ACTION_MANUAL_BILLING]: ['REASON_MANUAL_BILLING', REASON_OTHER],
  [UPDATE_COST_INCREMENT]: [
    'SHIPPER_ORDER_OF_RECURRING_ORDER_EDITED',
    'AGREEMENT_SHIPPER',
    'AGREEMENT_CARRIER',
    'CORNER_CASE',
    'CARRIER_NEGOCIATED_COST',
    'JOURNEY_NOT_ASSIGNED_BY_ITSELF',
    REASON_OTHER,
  ],
  [ACTION_OTHER]: [REASON_OTHER],
  [CANCEL_SHIPPER_ORDER]: [
    'REQUESTED_BY_SHIPPER',
    'LOAD_NOT_READY',
    'DRIVER_LATE_FOR_PICKUP',
    'DRIVER_NOT_FOUND',
    'DUPLICATED_ORDER',
    'LOAD_IS_NOT_WHAT_SHIPPER_SAID',
    'EXCEPTION_IN_RECURRING_ORDER',
    REASON_OTHER,
  ],
  [EMAIL_OFFER_SENT]: [REASON_OTHER],
  [JOURNEY_LAUNCHED_TO_POOL]: [REASON_OTHER],
  [SCAN_SKIPPED]: [REASON_OTHER],
  [CHAT_SENT_AUTOMATICALLY]: [REASON_OTHER],
};

const LOG_LOG_TYPE_BY_DEFAULT = {
  [ASSIGN_DRIVER]: LOG_INFO,
  [DELETE_CARGO_MANIFEST]: LOG_INFO,
  [CHANGE_JOURNEY_STATUS]: LOG_INFO,
  [UNASSIGN_DRIVER]: LOG_INFO,
  [UPDATE_SHIPPER_ORDER]: LOG_INFO,
  [EDIT_SHIPPER_ORDER_BY_SHIPPER]: '',
  [CREATE_SHIPPER_ORDER]: LOG_INFO,
  [UPDATE_PRICE]: LOG_INFO,
  [UPDATE_PRICE_BY_STANDSTILL]: LOG_INFO,
  [UPDATE_PRICE_BY_INCIDENT]: LOG_INFO,
  [UPLOAD_CARGO_MANIFEST]: LOG_INFO,
  [ACTION_MANUAL_BILLING]: LOG_INFO,
  [UPDATE_COST_INCREMENT]: LOG_INFO,
  [EMAIL_OFFER_SENT]: LOG_INFO,
  [ACTION_OTHER]: '',
  [JOURNEY_LAUNCHED_TO_POOL]: LOG_INFO,
  [SCAN_SKIPPED]: LOG_INFO,
  [APPOINTMENT_BOOKED]: LOG_INFO,
  [JOURNEY_STOP_TIME_UPDATED]: LOG_INFO,
  [CHAT_SENT_AUTOMATICALLY]: LOG_INFO,
};

const LOG_REASON_BY_DEFAULT = {
  [ASSIGN_DRIVER]: '',
  [UNASSIGN_DRIVER]: '',
  [UPDATE_PRICE]: '',
  [UPDATE_COST_INCREMENT]: '',
  [DELETE_CARGO_MANIFEST]: '',
  [CHANGE_JOURNEY_STATUS]: REASON_OTHER,
  [UPDATE_SHIPPER_ORDER]: REASON_OTHER,
  [EDIT_SHIPPER_ORDER_BY_SHIPPER]: REASON_OTHER,
  [CREATE_SHIPPER_ORDER]: REASON_OTHER,
  [UPDATE_PRICE_BY_STANDSTILL]: 'STANDSTILL',
  [UPDATE_PRICE_BY_INCIDENT]: 'INCIDENT',
  [UPLOAD_CARGO_MANIFEST]: REASON_OTHER,
  [ACTION_MANUAL_BILLING]: 'REASON_MANUAL_BILLING',
  [EMAIL_OFFER_SENT]: REASON_OTHER,
  [ACTION_OTHER]: REASON_OTHER,
  [JOURNEY_LAUNCHED_TO_POOL]: REASON_OTHER,
  [SCAN_SKIPPED]: 'DECIDED_BY_DRIVER',
  [APPOINTMENT_BOOKED]: REASON_OTHER,
  [CHAT_SENT_AUTOMATICALLY]: '',
};

const LOG_SHOW_LOG_TYPE = {
  [ASSIGN_DRIVER]: false,
  [DELETE_CARGO_MANIFEST]: false,
  [CHANGE_JOURNEY_STATUS]: false,
  [UNASSIGN_DRIVER]: false,
  [UPDATE_SHIPPER_ORDER]: false,
  [EDIT_SHIPPER_ORDER_BY_SHIPPER]: true,
  [CREATE_SHIPPER_ORDER]: false,
  [UPDATE_PRICE]: false,
  [UPDATE_PRICE_BY_STANDSTILL]: false,
  [UPDATE_PRICE_BY_INCIDENT]: false,
  [UPLOAD_CARGO_MANIFEST]: false,
  [ACTION_MANUAL_BILLING]: false,
  [UPDATE_COST_INCREMENT]: false,
  [EMAIL_OFFER_SENT]: false,
  [ACTION_OTHER]: true,
  [JOURNEY_LAUNCHED_TO_POOL]: false,
  [APPOINTMENT_BOOKED]: false,
  [CHAT_SENT_AUTOMATICALLY]: false,
};

const LOG_SHOW_REASONS = {
  [ASSIGN_DRIVER]: true,
  [DELETE_CARGO_MANIFEST]: true,
  [CHANGE_JOURNEY_STATUS]: false,
  [UNASSIGN_DRIVER]: true,
  [UPDATE_SHIPPER_ORDER]: false,
  [EDIT_SHIPPER_ORDER_BY_SHIPPER]: false,
  [CREATE_SHIPPER_ORDER]: false,
  [UPDATE_PRICE]: true,
  [UPDATE_PRICE_BY_STANDSTILL]: false,
  [UPDATE_PRICE_BY_INCIDENT]: false,
  [UPLOAD_CARGO_MANIFEST]: false,
  [ACTION_MANUAL_BILLING]: false,
  [UPDATE_COST_INCREMENT]: true,
  [EMAIL_OFFER_SENT]: false,
  [ACTION_OTHER]: false,
  [JOURNEY_LAUNCHED_TO_POOL]: true,
  [SCAN_SKIPPED]: true,
  [APPOINTMENT_BOOKED]: false,
  [CHAT_SENT_AUTOMATICALLY]: false,
};

export {
  LOG_INFO,
  LOG_INCIDENT,
  LOG_TASK,
  LOG_REASONS,
  LOG_LOG_TYPE_BY_DEFAULT,
  LOG_SHOW_LOG_TYPE,
  LOG_SHOW_REASONS,
  LOG_REASON_BY_DEFAULT,
  ACTION_OTHER,
  REASON_OTHER,
  ACTIONS_WITHOUT_COMMENT_FIELD,
  EMAIL_OFFER_SENT,
};
